import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { TrustBanner } from '@noths/polaris-design-system-candidate-components';

import type { TrustBannerViewModel } from 'src/components/layouts/hooks/useTrustBannerViewModel';
import { ServiceRating } from './ServiceRating';

export type TrustBannerWithTrackingProps = TrustBannerViewModel;

/**
 * The trust banner and its service rating. Content and impression tracking come
 * from useTrustBannerViewModel, so this stays props-only.
 */
export const TrustBannerWithTracking = ({
  onVisible,
  ...trustBannerProps
}: TrustBannerWithTrackingProps) => {
  const impressionRef = useImpressionRef<HTMLDivElement>(onVisible);

  return (
    <div ref={impressionRef}>
      <TrustBanner {...trustBannerProps} />
      <ServiceRating />
    </div>
  );
};
